exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "p[data-v-33b99a1e]{font-size:15px;text-align:justify}img[data-v-33b99a1e]{width:100%}", ""]);

// exports
